module.exports = __webpack_public_path__ + "static/media/-_overtime .4ab6fffe.png";